import "core-js/modules/es.array.find";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.function.name";
import "core-js/modules/es.string.link";

/*
 * Copyright (c) 2020 Wells Fargo. 45 Fremont Street, San Francisco, CA 94105 All rights reserved.
 *
 *This software is the confidential and proprietary information of Wells Fargo
 *bank. ('Confidential Information'). You shall not disclose such Confidential
 *Information and shall use it only in accordance with the terms of the license
 *agreement you entered into with WellsFargo.
 *
 *Author: Thomas Barry
*/
import React, { useContext } from 'react';
import { useDispatch } from 'react-redux';
import { getClasses } from '../../../lib/style-utils/style-utils';
import AccessibleClick from '../../accessible-click/AccessibleClick';
import Block from '../../block/Block';
import useBrand from '../../hooks/use-brand';
import useDevice from '../../hooks/use-device';
import Guttered from '../../guttered/Guttered';
import AccessibilityText from '../../accessibility-text/AccessibilityText';
import NavigationContext from '../../navigation-context/NavigationContext';
import ThePrivateBankLogo from '../support/logos/tpb-logo/ThePrivateBankLogo';
import GoFarRewardsLogo from '../support/logos/go-far-rewards-logo/GoFarRewardsLogo';
import WellsFargoAdvisorsLogo from '../support/logos/wfa-logo/WellsFargoAdvisorsLogo';
import styles from './SubLogo.less';
var subLogoBrands = ['tpb', 'wfa', 'gfr'];
var altText = {
  'tpb': 'The Private Bank',
  'wfa': 'Wells Fargo Advisors',
  'gfr': 'Go Far® Rewards'
};

var Logo = function Logo() {
  var brand = useBrand();
  return /*#__PURE__*/React.createElement(React.Fragment, null, 'tpb' === brand && /*#__PURE__*/React.createElement(ThePrivateBankLogo, null), 'wfa' === brand && /*#__PURE__*/React.createElement(WellsFargoAdvisorsLogo, null), 'gfr' === brand && /*#__PURE__*/React.createElement(GoFarRewardsLogo, null), /*#__PURE__*/React.createElement(AccessibilityText, null, altText[brand]));
};

var Link = function Link(_ref) {
  var link = _ref.link;
  var dispatch = useDispatch();

  var _useContext = useContext(NavigationContext),
      navigate = _useContext.navigate;

  var onClick = function onClick() {
    link && navigate({
      dispatch: dispatch,
      link: link
    });
  };

  return /*#__PURE__*/React.createElement(AccessibleClick, null, /*#__PURE__*/React.createElement("a", {
    role: "link",
    tabIndex: "0",
    onAccessibleClick: onClick
  }, /*#__PURE__*/React.createElement(Logo, null)));
};

var SubLogo = /*#__PURE__*/React.forwardRef(function (_ref2, ref) {
  var gutterClassNames = _ref2.gutterClassNames;
  var brand = useBrand();
  var device = useDevice();

  var _useContext2 = useContext(NavigationContext),
      getContainer = _useContext2.getContainer;

  var subLogoSection = getContainer('MASTHEAD_NAV').sections.find(function (_ref3) {
    var name = _ref3.name;
    return 'SUB' === name;
  });
  var subLogoLink = subLogoSection ? subLogoSection.links[0] : null;
  var classNames = getClasses({
    styles: styles,
    classes: ['subLogoContainer'],
    brand: brand,
    device: device
  });
  return subLogoLink && subLogoBrands.indexOf(brand) >= 0 ? /*#__PURE__*/React.createElement(Block, {
    layout: true,
    vertical: true,
    center: true,
    flex: true,
    className: classNames,
    elementRef: ref
  }, /*#__PURE__*/React.createElement(Guttered, {
    className: gutterClassNames
  }, /*#__PURE__*/React.createElement(Block, {
    layout: true,
    vertical: true,
    className: styles.subLogo
  }, subLogoLink.url ? /*#__PURE__*/React.createElement(Link, {
    link: subLogoLink
  }) : /*#__PURE__*/React.createElement(Logo, null)))) : null;
});
export default SubLogo;